import React, { useRef, useState } from 'react';
import { InformationCircleIcon, PencilIcon, BeakerIcon } from '@heroicons/react/24/outline';
import PortalModal from '../../Common/Modal/PortalModal';
import UpdateMixtureForm from '../Forms/UpdateMixtureForm';
import { useAuth } from '../../../context/AuthContext';
import { ROLES } from '../../../utils/roles.utils';
import ReagentsModal from '../../Capsules/ReagentsModal';

const MixturesRowActions = ({ table, row }) => {
    const { user } = useAuth();
    const [modalType, setModalType] = useState(null);
    const modalRef = useRef(null);
    const updateModalRef = useRef(null);

    const handleModal = (modal) => () => {
        if (updateModalRef.current) {
            updateModalRef.current.showModal();
        }
    };

    const reagents = row?.original.reagents
    const description = row?.original.description
    const mixtureName = row?.original.name

    return (
        <>
            <div className='flex space-x-2 items-center justify-end'>
                <ReagentsModal reagents={reagents} description={description} mixtureName={mixtureName} showPreview={false} iconSize='lg' />
                {user?.permission?.label === ROLES.ADMIN.label && window.location.pathname.includes('catalogue') &&
                    <button className='cursor-pointer text-base-content/50 hover:text-primary rounded-full p-1 transition-all duration-300' onClick={handleModal('update')}>
                        <PencilIcon title='Modifier' className="h-5 w-5" />
                    </button>
                }
                {window.location.pathname.includes('personnalises') &&
                    <button className='cursor-pointer text-base-content/50 hover:text-primary rounded-full p-1 transition-all duration-300' onClick={handleModal('update')}>
                        <PencilIcon title='Modifier' className="h-5 w-5" />
                    </button>
                }
            </div>

            {/* Modal pour la mise à jour - séparé pour éviter les conflits avec les autres modals */}
            <PortalModal ref={updateModalRef} size="2xl" className='p-0'>
                <div className='p-6'>
                    <div className='flex items-center gap-3 mb-4 border-b pb-4'>
                        <div className='bg-primary/10 p-2 rounded-full'>
                            <PencilIcon className='h-6 w-6 text-primary' />
                        </div>
                        <h2 className='text-lg font-bold space-x-2 w-full'><span className=' text-primary' >Edition du mélange : </span> <span className='font-normal'>{row.original.name}</span></h2>
                    </div>
                    <UpdateMixtureForm
                        rowIndex={row.index}
                        mixture={row.original}
                        table={table}
                        onCloseModal={() => {
                            console.log('close')
                            console.log(updateModalRef.current)
                            updateModalRef.current.hideModal();
                        }}
                    />
                </div>
            </PortalModal>


        </>
    );
};

export default MixturesRowActions;
